module.exports = __webpack_public_path__ + "img/pb_gallery_5.7e8da7fe.jpg";